import { useApiPatchRequest } from '@/api/rest/hooks/useApiPatchRequest';
import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  PATCH_PLOT_PORTFOLIO_SUBSCRIPTION_PATH,
  PatchPlotPortfolioSubscriptionErrorDto,
  PatchPlotPortfolioSubscriptionRequestBodyData,
  PatchPlotPortfolioSubscriptionRequestPathVariables,
  PlotPortfolioSubscription,
  POST_PLOT_PORTFOLIO_SUBSCRIPTION_PATH,
  PostPlotPortfolioSubscriptionErrorDto,
  PostPlotPortfolioSubscriptionRequestBodyData,
} from './types/plotPortfolioSubscriptions';

export const usePostPlotPortfolioSubscription = () => {
  return useApiPostRequest<
    undefined,
    undefined,
    PostPlotPortfolioSubscriptionRequestBodyData,
    PlotPortfolioSubscription,
    PostPlotPortfolioSubscriptionErrorDto
  >(POST_PLOT_PORTFOLIO_SUBSCRIPTION_PATH);
};

export const usePatchPlotPortfolioSubscription = () => {
  return useApiPatchRequest<
    PatchPlotPortfolioSubscriptionRequestPathVariables,
    undefined,
    PatchPlotPortfolioSubscriptionRequestBodyData,
    PlotPortfolioSubscription,
    PatchPlotPortfolioSubscriptionErrorDto
  >(PATCH_PLOT_PORTFOLIO_SUBSCRIPTION_PATH);
};
